import { ImageBlockSchema } from '@blocksuite/affine-model';
import {
  BlockMarkdownAdapterExtension,
  type BlockMarkdownAdapterMatcher,
  type MarkdownAST,
} from '@blocksuite/affine-shared/adapters';
import { getAssetName } from '@blocksuite/store';
import {
  FetchUtils
} from '@blocksuite/affine-shared/adapters';

import { processImageNodeToBlock } from './utils';

const isImageNode = (node: MarkdownAST) => node.type === 'image';

export const imageBlockMarkdownAdapterMatcher: BlockMarkdownAdapterMatcher = {
  flavour: ImageBlockSchema.model.flavour,
  toMatch: o => isImageNode(o.node),
  fromMatch: o => o.node.flavour === ImageBlockSchema.model.flavour,
  toBlockSnapshot: {
    enter: async (o, context) => {
      const { configs, walkerContext, assets, template } = context;
      const imageURL = 'url' in o.node ? o.node.url : '';
      if (!assets || !imageURL) {
        return;
      }
      await processImageNodeToBlock(imageURL, walkerContext, assets, configs, template);
    },
  },
  fromBlockSnapshot: {
    enter: async (o, context) => {
      const { assets, walkerContext, updateAssetIds, template } = context;
      const blobId = (o.node.props.sourceId ?? '') as string;
      let blobName = '', alt = (o.node.props?.alt as string || null);

      if(FetchUtils.fetchable(blobId) || template) {
        blobName = blobId;
      } else {
        if (!assets) {
          return;
        }
        await assets.readFromBlob(blobId);
        const blob = assets.getAssets().get(blobId);
        if (!blob) {
          return;
        }
        blobName = getAssetName(assets.getAssets(), blobId);
        blobName = `assets/${blobName}`;
        alt = (blob as File).name ?? null
      }


      updateAssetIds?.(blobId);
      walkerContext
        .openNode(
          {
            type: 'paragraph',
            children: [],
          },
          'children'
        )
        .openNode(
          {
            type: 'image',
            url: blobName,
            title: (o.node.props.caption as string | undefined) ?? null,
            alt,
          },
          'children'
        )
        .closeNode()
        .closeNode();
    },
  },
};

export const ImageBlockMarkdownAdapterExtension = BlockMarkdownAdapterExtension(
  imageBlockMarkdownAdapterMatcher
);
